import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { OPERATING_COMPANIES } from "@/domain/companies";
import { useAccessStore } from "@/store/access.store";
import { useAccess } from "@/hooks/useAccess";
function CompanySwitcher() {
  const activeCompanyId = useAccessStore((s) => s.activeCompanyId);
  const setActiveCompany = useAccessStore((s) => s.setActiveCompany);
  const { allowedCompanyIds } = useAccess();
  const companies = OPERATING_COMPANIES.filter((c) =>
    allowedCompanyIds.includes(c.id),
  );
  return (
    <FormControl size="small" sx={{ minWidth: 140 }}>
      <Select
        value={activeCompanyId}
        onChange={(e) => setActiveCompany(e.target.value)}
        sx={{ fontSize: 12, bgcolor: "background.paper" }}
      >
        {companies.map((c) => (
          <MenuItem key={c.id} value={c.id} sx={{ fontSize: 13 }}>
            {c.shortName}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
export { CompanySwitcher as default };
